import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
// import AuthSimpleLayout from './AuthSimpleLayout';
import is from 'is_js';
import MainLayout from './MainLayout';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import SettingsPanel from 'components/settings-panel/SettingsPanel';
import axios from '../api/axios';

import { toast, ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';

import AppContext from 'context/Context';

import ErrorLayout from './ErrorLayout';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';
import Profile from 'components/pages/user/profile/Profile';

import Dashboard from 'pages/parking/dashboard';
import ParkingRecap from 'pages/parking/recap';
import ParkingLocation from 'pages/parking/location';
import VehicleType from 'pages/parking/vehicle-type';

import Users from 'pages/application/users';
import Roles from 'pages/application/roles';
import Menus from 'pages/application/menus';

import CardLogin from 'components/authentication/card/Login';

const Layout = () => {
    const HTMLClassList = document.getElementsByTagName('html')[0].classList;
    const {
      config: { navbarPosition }
    } = useContext(AppContext);
    const navigate = useNavigate();

    // Const Variable
    const URL_NAVIGATION = '/apps/navigation';
  
    // state Variable
    const [menus, setMenus] = useState([]);
    const [accessUser, setAccessUser] = useState(false);
  
    useEffect(() => {
      if (is.windows()) {
        HTMLClassList.add('windows');
      }
      if (is.chrome()) {
        HTMLClassList.add('chrome');
      }
      if (is.firefox()) {
        HTMLClassList.add('firefox');
      }
      if (is.safari()) {
        HTMLClassList.add('safari');
      }
    }, [HTMLClassList]);
  
    useEffect(() => {
      if (navbarPosition === 'double-top') {
        HTMLClassList.add('double-top-nav-layout');
      }
      return () => HTMLClassList.remove('double-top-nav-layout');
    }, [HTMLClassList, navbarPosition]);
  
    useEffect(() => {
      const item = JSON.parse(localStorage.getItem('accessUser'));
      if (item) {
        setAccessUser(item);
        getMenus(item.token, item.role);
      } else {
        navigate('login');
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getMenus = async (token, roleUser) => {
      const bearerToken = accessUser.token ? accessUser.token : token
      const role = accessUser.role ? accessUser.role : roleUser;
      try {
        const response = await axios.get(URL_NAVIGATION + '?role=' + role, {
          headers: {
            'Authorization': `Bearer ${bearerToken}`
          }
        });
        setMenus(response?.data);
      } catch (err) {
        if (!err?.response) {
          toast.error('No Server Response');
        } else if (err?.response.status === 400) {
          toast.error(err?.response.data.message);
        } else if (err?.response.status === 401) {
          toast.error(err?.response.data.message);
          localStorage.removeItem('accessUser');
          navigate('/login');
        }
      }
    }

    return (
      <>
          <Routes>
              <Route path="login" element={<CardLogin />} />

              <Route element={<ErrorLayout />}>
                  <Route path="errors/404" element={<Error404 />} />
                  <Route path="errors/500" element={<Error500 />} />
              </Route>

              <Route element={<MainLayout menus = {menus} accessUser = {accessUser} />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/main/rekap-parkir" element={<ParkingRecap />} />
                  <Route path="/master/lokasi" element={<ParkingLocation />} />
                  <Route path="/master/tipe-kendaraan" element={<VehicleType />} />
                  <Route path="user/profile" element={<Profile />} />
                  <Route path="application/users" element={<Users />} />
                  <Route path="application/roles" element={<Roles />} />
                  <Route path="application/menus" element={<Menus />} />
              </Route>
              
              <Route path="*" element={<Navigate to="/errors/404" replace />} />
          </Routes>
          <SettingsToggle />
          <SettingsPanel />
          <ToastContainer
              closeButton={CloseButton}
              icon={false}
              position={toast.POSITION.TOP_CENTER}
          />
      </>
    );
}

export default Layout;